<template>
  <zl-dialog class="zl-saas" title="发起谈判" ref="dialog" width="960px">
    <el-form
      :model="form"
      :rules="rules"
      label-width="150px"
      label-position="left"
      ref="ruleForm"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="谈判次数限制">
            <el-radio-group v-model="limtCount" :disabled="isDisabledEdit" @change="changeLimtCount">
              <el-radio :label="false">不限制</el-radio>
              <el-radio :label="true">限制</el-radio>
              <el-radio :label="-99">不谈判</el-radio>
            </el-radio-group>
            <el-checkbox v-model="againTanPan" style="margin-left: 20px;" @change="againTanPanFun" :disabled="inquireStatus !== 8">再次谈判</el-checkbox>
            <div v-if="limtCount === true" class="tanpan-times-wrapper">
              <span>{{ tanPanDesc }}</span>
              <el-form-item prop="negoTimes">
                <el-input-number
                  size="mini"
                  v-model="form.negoTimes"
                  controls-position="right"
                  :disabled="isDisabledEdit"
                  :min="0"
                  @change="changeNegoTimes"
                ></el-input-number>
              </el-form-item>
              <span> 次</span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="limtCount != -99">
        <el-col :span="12">
          <el-form-item label="谈判截止时间" prop="negoEndTime">
            <el-date-picker
              v-model="form.negoEndTime"
              type="datetime"
              placeholder="选择时间"
              :disabled="formDisabled"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="limtCount != -99">
        <el-col :span="12">
          <el-form-item label="当前谈判轮次">
            第{{ form.negoCount + 1 }}轮
            <el-checkbox v-model="zuiHouYiLunTanPan" style="margin: 0 10px;" :disabled="lastDisabled || formDisabled">最后一轮谈判</el-checkbox>
            <el-popover
              placement="right"
              title=""
              trigger="hover"
            >
              <i class="el-icon-question" slot="reference"></i>
              <div style="color:#ff9500">
                当前谈判轮次为最后一轮时，请勾选该选项
              </div>
            </el-popover>
            <!-- <span style="color:#ff3f3f;" v-if="(form.negoCount + 1) === form.negoTimes">当前是最后一轮!</span> -->
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="limtCount != -99">
        <el-col :span="24">
          <el-form-item label="采购人谈判说明">
            <el-input v-model="form.negoExplain" type="textarea" :disabled="formDisabled"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template v-if="limtCount != -99">
      <div class="zs-title m-t-20 m-b-5">
        <span>选择谈判供应商</span>
      </div>
      <el-table
        :data="inquireSupplierDTO"
        @selection-change="handleSelectionChange"
      >
        <el-table-column align="center" type="selection" width="55" :selectable="(row) => row.quote" />
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="供应商名称" prop="supplierName">
          <template slot-scope="scope">
            <span>{{ scope.row.supplierName }}</span>
            <span v-if="!scope.row.quote" class="gold-tag">未报价</span>
          </template>
        </el-table-column>
        <el-table-column label="最终报价(元)" prop="endPrice">
          <template slot-scope="{ row }">
            <span> {{ isShowPrice ? row.endPrice : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="币种" prop="currencyCh"></el-table-column>
        <el-table-column
          label="接受次数/谈判总次数"
          prop="supplierName"
          min-width="100px"
        ></el-table-column>
        <el-table-column label="谈判回复" prop=""></el-table-column>
        <el-table-column label="回复时间" prop=""></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="checkDetail(scope.row)">
              查看
            </el-button>
            <el-button type="text" @click="checkTpDetail(scope.row)">
              谈判详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template slot="footer">
      <el-button size="small" plain type="primary" @click="cancel">
        取消
      </el-button>
      <el-button size="small" type="primary" :loading="btnLoading" @click="submit">确定</el-button>
    </template>
  </zl-dialog>
</template>

<script>
import store from '@/store'
import dayjs from 'dayjs'
import baojiaDetail from './baojiaDetail'
import tanpanDetail from './tanpanDetail'
import { cloneDeep } from 'lodash-es'
export default {
  data() {
    return {
      limtCount: false,
      form: {
        negoEndTime: null, // 谈判截止时间
        negoTimes: 0, // 谈判数据限制0-不限制
        inquireId: '', // 询单主键
        negoExplain: '' // 邀请谈判说明
      },
      rules: {
        negoEndTime: [
          { required: true, message: '请输入谈判截止时间', trigger: 'blur' }
        ],
        negoTimes: [{
          pattern: /^(([1-9]\d+)|([1-9]))$/,
          message: '请输入大于等于1的整数',
          trigger: 'blur'
        }]
      },
      inquireSupplierDTO: [],
      selectedSupplier: [],
      isDisabledEdit: false,
      finishTime: '',
      inquireId: '',
      zuiHouYiLunTanPan: false,
      inquireStatus: '', // 8 谈判结束
      againTanPan: false,
      oldForm: {},
      formDisabled: false,
      btnLoading: false,
      tanPanDesc: '谈判次数<=',
      sysTime: null
    }
  },
  computed: {
    isShowPrice() {
      const nowTime = dayjs().valueOf()
      if (this.finishTime) {
        if (nowTime < +this.finishTime) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    lastDisabled() {
      if (this.inquireStatus === 8) {
        return this.form.negoCount + 1 === this.form.negoTimes + this.form.negoCount && this.limtCount === true
      } else {
        return (this.form.negoCount + 1 === this.form.negoTimes && this.limtCount === true) || (this.form.zaiCiTanPan === 1 && this.form.zaiCiTanPanCiShu === 1)
      }
      // return (this.form.negoCount + 1 === this.form.negoTimes && this.limtCount === true) || (this.form.zaiCiTanPan === 1 && this.form.zaiCiTanPanCiShu === 1)
    }
  },
  methods: {
    changeLimtCount() {
      this.zuiHouYiLunTanPan = this.form.negoCount + 1 === this.form.negoTimes && this.limtCount === true
    },
    changeNegoTimes() {
      this.zuiHouYiLunTanPan = this.form.negoCount + 1 === this.form.negoTimes && this.limtCount === true
    },
    againTanPanFun(val) {
      if (val) {
        if (this.limtCount === -99) { // 不谈判
          this.limtCount = false
          this.form.negoCount = 0
          this.isDisabledEdit = false
          this.formDisabled = false
        } else {
          this.limtCount = this.form.negoTimes > 0
          this.formDisabled = false
        }
      } else {
        if (this.form.zuiHouYiLunTanPan && !this.againTanPan) {
          this.zuiHouYiLunTanPan = true
        }
        this.formDisabled = true
        this.form = cloneDeep(this.oldForm)
        this.isDisabledEdit = true
        this.limtCount = this.form.negoTimes > 0
        if (this.form.negoTimes === -99) {
          this.limtCount = -99
        }
      }
    },
    open(args) {
      this.finishTime = args.finishTime
      this.inquireId = args.inquireId
      this.inquireStatus = args.inquireStatus
      console.log('---------------- inquireStatus', this.inquireStatus)
      store
        .dispatch('listSupplierByInquireId', {
          inquireId: args.inquireId
        })
        .then((res) => {
          this.inquireSupplierDTO = res
        })
      store
        .dispatch('getInquireNego', {
          id: args.inquireId
        })
        .then((res) => {
          this.form = {
            ...res,
            negoTimes: res.negoTimes || 0,
            // negoEndTime: res.negoEndTime && dayjs(res.negoEndTime),
            negoEndTime: null,
            negoExplain: '',
            inquireId: args.inquireId
          }
          this.oldForm = cloneDeep(this.form)
          this.limtCount = res.negoTimes > 0
          if (res.negoTimes === -99) {
            this.limtCount = -99
          }
          this.zuiHouYiLunTanPan = this.form.negoCount + 1 === this.form.negoTimes
          if (this.form.zaiCiTanPan === 1 && this.form.zaiCiTanPanCiShu === 1) {
            this.zuiHouYiLunTanPan = true
          }
          // 判断谈判次数是否可以编辑
          // if(projectNegoTimes == 有值){//说明在所选合同处已经设置规则了，，
          // 不可编辑 （谈判次数限制设置就是projectNegoTimes设置 ）
          // }else{
          // if(negoTimes == 有值){//说明已经发起过一轮了
          // 不可编辑 （谈判次数限制设置就是negoTimes设置 ）
          // }else{//既没有合同设置值，又是首次发起谈判
          //      可编辑
          // }
          // }
          if ((res.projectNegoTimes !== '' && res.projectNegoTimes !== null && res.projectNegoTimes > 0) || (res.negoTimes !== '' && res.negoTimes !== null)) {
            this.isDisabledEdit = true
          } else {
            this.isDisabledEdit = false
          }
          if (this.inquireStatus === 8) {
            this.formDisabled = true
            if (this.form.zuiHouYiLunTanPan && !this.againTanPan) {
              this.zuiHouYiLunTanPan = true
            }
            // this.againTanPan = true
            // this.againTanPanFun(true)
          }
        })
      return this.$refs.dialog.open()
    },
    cancel() {
      this.$refs.dialog.cancel()
    },
    submit() {
      if (this.limtCount === -99) {
        this.btnLoading = true
        store.dispatch('tanPanJieShu', { inquireId: this.inquireId }).then(res => {
          this.btnLoading = false
          this.$zl.message.success('提交成功')
          return this.$refs.dialog.close()
        })
      } else {
        this.confirm()
      }
    },
    // getSystemTime() {
    //   store.dispatch('getSystemTime', {}).then(res => {
    //     this.sysTime = res.dateTime
    //   })
    // },
    async confirm() {
      // if (!this.form.negoEndTime) {
      //   this.$zl.message.warn('请填写谈判截止时间！')
      //   return
      // }
      if (this.limtCount === false) {
        this.form.negoTimes = 0
      }
      this.$refs.ruleForm.validate(async(valid) => {
        if (valid) {
          if (this.selectedSupplier && this.selectedSupplier.length < 1) {
            this.$message.warning('请选择谈判供应商！')
            return
          }
          store.dispatch('getSystemTime', {}).then(res => {
            const sysTime = res.dateTime
            const negoEndTime = dayjs(this.form.negoEndTime).valueOf()
            if (negoEndTime <= sysTime) {
              this.$message.warning('谈判截止时间必须大于服务器时间！')
              return false
            }
            this.btnLoading = true
            store
              .dispatch('saveInquireNego', {
                ...this.form,
                negoEndTime: dayjs(this.form.negoEndTime).valueOf(),
                inquireSupplierDTO: this.selectedSupplier,
                zuiHouYiLunTanPan: this.zuiHouYiLunTanPan ? 1 : 0,
                zaiCiTanPan: this.againTanPan ? 1 : 0
              })
              .then((res) => {
                this.btnLoading = false
                this.$zl.message.success('提交成功')
                return this.$refs.dialog.close()
              })
          })
        }
      })
    },
    checkDetail(row) {
      this.$zl.dialog.openFull(baojiaDetail, { row: row, fileId: row.fileId })
    },
    handleSelectionChange(val) {
      this.selectedSupplier = val
    },
    checkTpDetail(row) {
      this.$zl.dialog.openFull(tanpanDetail, {
        row
        // showPrice: this.showPrice,
        // fileId: row.fileId
      })
    }
  }
}
</script>

<style>
.tanpan-times-wrapper{
  display: flex;
}
</style>
